"use client";

import { useEffect, useState } from "react";

/**
 * スクロール時にヘッダーへ影を付与するためのクライアントコンポーネント。
 * layout.tsx の Header に埋め込んで使用する。
 */
export function ScrollShadowHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const header = document.querySelector("header");
    if (!header) return;
    if (scrolled) {
      header.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
    } else {
      header.style.boxShadow = "";
    }
  }, [scrolled]);

  return null;
}
